import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses';
import { pcsMsg, t } from '../../common/i18n';
import type { DiscontinuedProduct } from '../../generated/api/discontinuedProduct';

interface ViewDiscontinuedDevicesProps {
  discontinuedProducts: DiscontinuedProduct[];
}

export const ViewDiscontinuedDevices = ({ discontinuedProducts }: ViewDiscontinuedDevicesProps) => {
  if (discontinuedProducts.length === 0) {
    return null;
  }

  const displayText = `${t.GL4B('Products removed from selection')} (${discontinuedProducts.length} ${t.B3MG(pcsMsg)})`;
  const additionalInfo = t.V6RV(
    'The products removed from selection are no longer available, so they are not shown on employees’ device lists.'
  );

  return (
    <div className={`${dsClass.PADDING_TOP_3} ${dsClass.PADDING_BOTTOM_6}`}>
      <CL.Description columns={1} items={[{ title: displayText, description: additionalInfo }]} />

      <div className="of-catalog-details__discontinued-devices-published__list">
        {discontinuedProducts.map((device, index) => (
          <div className="of-catalog-details__discontinued-devices-published__list_item" key={index}>
            {device.onlineModelName}
          </div>
        ))}
      </div>
    </div>
  );
};
